module.exports = __webpack_public_path__ + "static/media/walk_kids.499e2297.svg";